import manifestManager from "flow/utils/manifestManager";
import config from "flow/config";
import viewCache from "flow/utils/viewCache";
import MyFlow from "flow/MyFlow";
import { Dictionary } from "flow/api/types";

export interface IDefaultWorkingContextViewContext {
    id: string;
    args: Dictionary;
}

// I create my own manifest
manifestManager.addManifests(config.moduleId, [
    {
        id: config.componentIds.defaultWorkingContext,
        isWorkingContext: true,
        namespace: "default",
        reuseInstance: true,
        viewModelId: "flow/viewModels/DefaultWorkingContextViewModel",
        viewUrl: "virtual/DefaultContext"
    }
]);

viewCache.inject("virtual/DefaultContext", "");

export default class DefaultWorkingContextViewModel {
    currentViewModelId = "";

    constructor(private readonly myFlow: MyFlow) {}

    activate(viewContext: IDefaultWorkingContextViewContext) {
        if (viewContext != undefined) {
            this.currentViewModelId = viewContext.id;
            this.myFlow.activateById(viewContext.id, viewContext.args);
            this.myFlow.selectById(viewContext.id, undefined, true);
        }
    }

    shouldBeVisible(componentId: string) {
        return this.currentViewModelId === componentId;
    }

    getCurrentFunctionComponentId() {
        return this.currentViewModelId;
    }

    currentFunctionComponentId = this.getCurrentFunctionComponentId;
}
